import { BaseThunkType, InferActionsTypes } from "./store";
import { IError, IToken, IUserData } from "../types/auth";
import axios from "axios";
import { Dispatch } from "redux";
import { orderApi } from "../api/order-api";
import { navigate } from "@reach/router";
import { actions as loadingActions } from "./loading";
import { actions as servicesActions } from "./services";

const initialState = {
  user: null as IUserData | null,
  token: "",
  refresh: "",
  loggedIn: 0,
  error: null as null | IError,
  open: false,
  successModalOpen: false,
};

type InitialState = typeof initialState;
type Actions = InferActionsTypes<typeof actions>;
type ThunkType = BaseThunkType<Actions>;

const orderReducer = (state = initialState, action: Actions): InitialState => {
  switch (action.type) {
    case "SETTING_USER_DATA": {
      return {
        ...state,
        user: {
          ...action.payload,
        },
        loggedIn: 1,
        error: null,
      };
    }
    case "SET_ORDER_ERROR": {
      return {
        ...state,
        error: {
          ...state.error,
        },
      };
    }
    case "SET_TOGGLE_CART": {
      return {
        ...state,
        open: action.payload,
      };
    }
    case "SET_MODAL_OPEN": {
      return {
        ...state,
        successModalOpen: action.payload,
      };
    }
    default:
      return state;
  }
};

export const order = (formData: any): ThunkType => {
  return async (dispatch) => {
    try {
      //@ts-ignore
      dispatch(loadingActions.setLoading());
      const response = await orderApi.order(formData);
      if (response.status === 200 || response.status === 201) {
        //@ts-ignore
        dispatch(loadingActions.setLoaded());
        //@ts-ignore
        dispatch(servicesActions.resetCart());
        //@ts-ignore
        dispatch(actions.setModalOpen(true));

        setTimeout(() => {
          dispatch(actions.setModalOpen(false));
        }, 2000);

        if (response.data) {
          return response.data;
          // dispatch(actions.setLoggedIn(response.data.access));
          // await dispatch(getUserData());
        }
      }
    } catch (e: any) {
      //@ts-ignore
      dispatch(loadingActions.setLoaded());
      dispatch(actions.setError(e));
    }
  };
};

export const actions = {
  setUser: (user: IUserData) =>
    ({ type: "SETTING_USER_DATA", payload: user } as const),
  setError: (e: Error) => ({ type: "SET_ORDER_ERROR", payload: e } as const),
  setToggle: (e: boolean) => ({ type: "SET_TOGGLE_CART", payload: e } as const),
  setModalOpen: (e: boolean) =>
    ({ type: "SET_MODAL_OPEN", payload: e } as const),
};

export default orderReducer;
